import React from 'react';
import propTypes from 'prop-types';

export default function CarrierAppointmentVideo({ src, className }) {
  if (!src) return null;

  return (
    <div
      className={className}
      style={{
        aspectRatio: '16 / 9',
        width: '100%',
        maxWidth: '100%',
        backgroundColor: '#000',
        borderRadius: 6,
        overflow: 'hidden'
      }}
    >
      <video
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          display: 'block'
        }}
        controls
        playsInline
        preload='metadata'
      >
        <source src={src} />
      </video>
    </div>
  );
}

CarrierAppointmentVideo.propTypes = {
  src: propTypes.string,
  className: propTypes.string
};
